import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SharedApplication,
  ClientSharingState,
  SharedApplicationsCounts,
  SharedApplicationsDashboardCounts,
} from "../types/clientSharingTypes";

const initialState: ClientSharingState = {
  sharedApplications: [],
  sharedApplicationsCount: 0,
  totalCount: 0,
  shortlistedCount: 0,
  rejectedCount: 0,
  dashboardCounts: null,
  loading: false,
  error: null,
};

const clientSharingSlice = createSlice({
  name: "clientSharing",
  initialState,
  reducers: {
    setSharedApplications: (
      state: ClientSharingState,
      action: PayloadAction<SharedApplication[]>
    ) => {
      state.sharedApplications = action.payload;
    },
    setSharedApplicationsCount: (
      state: ClientSharingState,
      action: PayloadAction<number>
    ) => {
      state.sharedApplicationsCount = action.payload;
    },
    setSharedApplicationsCounts: (
      state: ClientSharingState,
      action: PayloadAction<SharedApplicationsCounts>
    ) => {
      const { filtered_count, total_count, shortlisted_count, rejected_count } =
        action.payload;
      state.sharedApplicationsCount = filtered_count ?? 0;
      state.totalCount = total_count ?? 0;
      state.shortlistedCount = shortlisted_count ?? 0;
      state.rejectedCount = rejected_count ?? 0;
    },
    setSharedApplicationsLoading: (
      state: ClientSharingState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    setSharedApplicationsError: (
      state: ClientSharingState,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload;
    },
    setSharedApplicationsDashboardCounts: (
      state: ClientSharingState,
      action: PayloadAction<SharedApplicationsDashboardCounts | null>
    ) => {
      state.dashboardCounts = action.payload;
    },
  },
});

export const {
  setSharedApplications,
  setSharedApplicationsCount,
  setSharedApplicationsCounts,
  setSharedApplicationsLoading,
  setSharedApplicationsError,
  setSharedApplicationsDashboardCounts,
} = clientSharingSlice.actions;

export default clientSharingSlice.reducer;
